import { css, Theme } from '@mui/material'

export const root = css`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const row = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const wrapper = (theme: Theme) => css`
  width: 100%;
  display: flex;
  max-width: 1280px;
  padding: 0 ${theme.spacing(16)};
  align-items: center;
  gap: ${theme.spacing(6)};

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    padding: 0 ${theme.spacing(8)};
    gap: ${theme.spacing(4)};
  }

  ${theme.breakpoints.down('sm')} {
    padding: 0 ${theme.spacing(4)};
    gap: ${theme.spacing(3)};
  }
`

export const leftCol = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
  text-align: left;

  ${theme.breakpoints.down('md')} {
    width: 100%;
    align-items: center;
    text-align: center;
  }
`

export const brandRow = (theme: Theme) => css`
  display: flex;
  align-items: center;

  ${theme.breakpoints.down('md')} {
    justify-content: center;
  }
`

export const brandLogo = (theme: Theme) => css`
  display: block;
  width: 300px;
  height: auto;
  background-color: transparent;
  object-fit: contain;
  margin: -15px 0;

  ${theme.breakpoints.down('sm')} {
    width: 150px;
    height: auto;
    margin-top: ${theme.spacing(2)};
  }
`

export const headline = (theme: Theme) => css`
  margin: 0;
  width: 95%;
  margin-top: ${theme.spacing(4)};
  font-weight: 600;
  color: #0b2948;
  font-size: clamp(1.25rem, 0.9rem + 1.5vw, 1.75rem);
  text-shadow:
    0 0 16px rgba(0, 0, 0, 0.1),
    -1px 0 0 #fff8;
  line-height: 120%;

  ${theme.breakpoints.down('md')} {
    margin-top: ${theme.spacing(3)};
    font-size: 1.25rem;
  }
`

export const rightCol = (theme: Theme) => css`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${theme.spacing(8)};

  & > img {
    width: 100%;
    height: auto;
    object-fit: contain;
    max-width: 640px;
  }

  ${theme.breakpoints.down('md')} {
    width: 100%;
    margin-top: ${theme.spacing(4)};

    & > img {
      max-width: 100%;
    }
  }

  ${theme.breakpoints.down('sm')} {
    width: 100%;
    margin-top: ${theme.spacing(3)};
  }
`

export const spacer = css`
  flex-grow: 1;
  height: 100%;
`
